import React, { useState, useEffect } from 'react'
import ErrorHandler from '../../error-handler/ErrorHandler'
import axiosInstance from '../../api/axiosInstance'
import ModifiedForm from '../layout/form/ModifiedForm'
import { TextField } from '../layout/form/TextInputFields';
import { useTranslation } from 'react-i18next';
import { Row, Col } from "react-bootstrap";


const EditCategory = (props) => {
    const { t } = useTranslation();

    const [data, setData] = useState("")
    const getDetails = async () => {
        let result = await axiosInstance.get(`/category/${props.match.params.id}`)
        if (result) {
            console.log(result.data)
            setData(result.data)
        }
    }

    async function submitJob(data) {
        try {
            const res = await axiosInstance.put(`/category/${props.match.params.id}`, data);
            return { type: 1, message: t("success") }
        }
        catch (e) {

            return { type: 2, message: e.response.data }

        }
    }
    useEffect(() => {
        getDetails()
    }, [])

    return (
        <>
            <ModifiedForm
                submitFunction={submitJob}
                isReset={false}
            >
                <Row>

                    <h4 className="title">{t("editJobs")}</h4>

                    <Col lg={6}>
                        <TextField
                            className="formTextField"
                            id={"title_ar"}
                            title={t("form.nameAR")}
                            initial={data?.title_ar}
                        />
                    </Col>
                    <Col lg={6}>
                        <TextField
                            className="formTextField"
                            id={"title_en"}
                            title={t("form.nameEN")}
                            initial={data.title_en}
                        />
                    </Col>

                </Row>
                <Row>
                    <Col lg={6}>
                        <TextField
                            className="formTextField"
                            id={"privs_ar"}
                            validation={{
                                required: true,
                            }}
                            title={t("category.privsAR")}
                            initial={data.privs_ar}
                        />

                    </Col>
                    <Col lg={6}>
                        <TextField
                            className="formTextField"
                            id={"privs_en"}
                            validation={{
                                required: true,
                            }}
                            title={t("category.privsEN")}
                            initial={data.privs_en}

                        />
                    </Col>
                </Row>

                <div className="formSubmit">
                    <button className="defaultButton" type="submit" >
                        {t("buttons.finish")}
                    </button>
                </div>
            </ModifiedForm>
        </>
    )
}

export default ErrorHandler(EditCategory, axiosInstance)